import packageJson from "../../package.json";

export const APP_VERSION = packageJson.version;
export const ALGORITHM_VERSION = "3.1.0";
export const PROJECT_SCHEMA_VERSION = 3 as const;
